import VWave from 'v-wave'

import { setupDictionaryBootstrap } from '@/bootstrap/dictionary'
import { defaultProTableDefaults, installProTableDefaults } from '@/config/proTable'
import { setupVxeTable } from '@/config/vxeTable'
// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'
import icons from '@/iconify/index.json'
// 自定义指令
import directive from '@/utils/directive'

// 错误日志上报
import errorLog from '@/utils/errorLog'
import App from './App.vue'
import i18n from './locales'
import router from './router'
import pinia from './store'
import uiProvider from './ui/provider'

import '@/utils/storage'
// UnoCSS
import 'virtual:uno.css'

// 全局样式
import '@/assets/styles/globals.css'

const app = createApp(App)
app.use(VWave, {})
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(i18n)
setupVxeTable(pinia)
installProTableDefaults(app, defaultProTableDefaults)
directive(app)
errorLog(app)
setupDictionaryBootstrap(pinia)
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

app.mount('#app')
